import { csrfToken, csrfTokenValue } from '@/common/utils/securityUtilities';
var FetchSettingsFactory = /** @class */ (function () {
    function FetchSettingsFactory() {
    }
    FetchSettingsFactory.prototype.createGet = function () {
        return {
            headers: this.getRequestHeaders(),
            credentials: 'same-origin' // Needed because of FF ESR - fixed in 61.0b13.
        };
    };
    FetchSettingsFactory.prototype.createPut = function (body) {
        return {
            method: 'put',
            headers: this.getRequestHeaders(),
            credentials: 'same-origin',
            body: body
        };
    };
    FetchSettingsFactory.prototype.createPost = function (body) {
        return {
            method: 'post',
            headers: this.getRequestHeaders(),
            credentials: 'same-origin',
            body: body
        };
    };
    FetchSettingsFactory.prototype.createDelete = function (body) {
        return {
            method: 'delete',
            headers: this.getRequestHeaders(),
            credentials: 'same-origin',
            body: body
        };
    };
    FetchSettingsFactory.prototype.getRequestHeaders = function () {
        var headers = new Headers();
        headers.append("pragma", "no-cache");
        headers.append("cache-control", "no-cache");
        headers.append("content-type", "application/json");
        headers.append("connection", "keep-alive");
        headers.append(csrfToken, csrfTokenValue());
        return headers;
    };
    return FetchSettingsFactory;
}());
export default FetchSettingsFactory;
